import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from '../../axios';

const STATUS_LABELS = {
  active: '有効',
  stopped: '停止',
  reached: '上限到達',
  unset: '未設定',
};

const PrPointSection = ({ limit, consumed, remaining, efficiency, status, eventId, purchaseUrl, onDataChange }) => {
  var isActive = status === 'active' || status === 'reached';
  var isStopped = status === 'stopped';
  var canEdit = isActive || isStopped || status === 'unset';

  const [editLimit, setEditLimit] = useState(limit !== null ? String(limit) : '');
  const [processing, setProcessing] = useState(null);

  const handleUpdateLimit = async () => {
    setProcessing('update');
    try {
      var limitValue = editLimit === '' ? null : parseInt(editLimit, 10);
      await axios.post('/api/events/' + eventId + '/pr_limitations/update', {
        event_id: eventId,
        limit: limitValue,
      });
      if (onDataChange) onDataChange();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || '設定の更新に失敗しました';
      alert(msg);
    }
    setProcessing(null);
  };

  const handleDeactivate = async () => {
    setProcessing('toggle');
    try {
      await axios.post('/api/events/' + eventId + '/pr_limitations/deactivate', {
        event_id: eventId,
      });
      if (onDataChange) onDataChange();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || '停止処理に失敗しました';
      alert(msg);
    }
    setProcessing(null);
  };

  const handleActivate = async () => {
    setProcessing('toggle');
    try {
      var limitValue = editLimit === '' ? null : parseInt(editLimit, 10);
      await axios.post('/api/events/' + eventId + '/pr_limitations/update', {
        event_id: eventId,
        limit: limitValue,
      });
      if (onDataChange) onDataChange();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || '再開処理に失敗しました';
      alert(msg);
    }
    setProcessing(null);
  };

  return (
    <div className="o-dashboard__section">
      <h3 className="o-dashboard__section-title">PRポイント</h3>
      <div className="o-pr-point">
        <div className="o-pr-point__header">
          <div>
            <span className="o-pr-point__stat">消費: <strong>{Number(consumed).toLocaleString()}</strong> pt</span>
            <span className="o-pr-point__stat">残: <strong>{remaining !== null ? Number(remaining).toLocaleString() : '-'}</strong> pt</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className={'o-pr-point__status o-pr-point__status--' + status}>
              {STATUS_LABELS[status] || status}
            </span>
            {purchaseUrl && (
              <a href={purchaseUrl} className="a-button a-button--primary">
                PRチケット購入
              </a>
            )}
          </div>
        </div>
        <div className="o-pr-point__stat" style={{ marginTop: '8px' }}>
          PR効率: <strong>{efficiency}</strong> PV/pt
        </div>
        {canEdit && (
          <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <label style={{ fontSize: '13px', color: '#555' }}>消費上限:</label>
            <input
              type="number"
              value={editLimit}
              placeholder="無制限"
              min={consumed + 1}
              disabled={!canEdit}
              onChange={function (e) { setEditLimit(e.target.value); }}
              style={{ width: '100px', padding: '4px 6px', fontSize: '13px' }}
            />
            <span style={{ fontSize: '12px', color: '#888' }}>pt</span>
            <button
              type="button"
              onClick={handleUpdateLimit}
              disabled={processing === 'update'}
              style={{ fontSize: '12px', padding: '4px 12px', cursor: 'pointer', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px' }}
            >
              {processing === 'update' ? '処理中...' : (status === 'unset' ? '設定を保存 & 開始' : '上限更新')}
            </button>
            {isActive && (
              <button
                type="button"
                onClick={handleDeactivate}
                disabled={processing === 'toggle'}
                style={{ fontSize: '12px', padding: '4px 12px', cursor: 'pointer', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px' }}
              >
                {processing === 'toggle' ? '処理中...' : 'ポイント利用を停止'}
              </button>
            )}
            {isStopped && (
              <button
                type="button"
                onClick={handleActivate}
                disabled={processing === 'toggle'}
                style={{ fontSize: '12px', padding: '4px 12px', cursor: 'pointer', background: '#22c55e', color: '#fff', border: 'none', borderRadius: '4px' }}
              >
                {processing === 'toggle' ? '処理中...' : 'ポイント利用を再開'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

PrPointSection.propTypes = {
  limit: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  consumed: PropTypes.number.isRequired,
  remaining: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  efficiency: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  eventId: PropTypes.number.isRequired,
  purchaseUrl: PropTypes.string,
  onDataChange: PropTypes.func,
};

export default PrPointSection;
